import FeatureFlagsWrapper from "./FeatureFlagsWrapper";

export default FeatureFlagsWrapper;
